
import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { appStoreUrlFloatingCta, googlePlayUrlFloatingCta } from '@/utils/appStoreUtm';

export default function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const { id: articleId } = useParams<{ id?: string }>();
  const { pathname } = useLocation();
  const appStoreHref = useMemo(
    () => appStoreUrlFloatingCta(pathname, articleId),
    [pathname, articleId]
  );
  const googlePlayHref = useMemo(
    () => googlePlayUrlFloatingCta(pathname, articleId),
    [pathname, articleId]
  );

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 z-50 animate-fade-in px-4 w-full max-w-md sm:max-w-none sm:w-auto">
      <div className="bg-white/90 backdrop-blur-md rounded-full px-4 sm:px-6 py-2 sm:py-3 shadow-2xl border border-gray-200/50">
        <div className="flex items-center space-x-2 sm:space-x-4">
          <span className="text-xs sm:text-sm font-medium text-[#111827]">
            今すぐアプリをダウンロード
          </span>
          <div className="flex space-x-2">
            <a
              href={appStoreHref}
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#02D0F0] hover:bg-[#07DBCA] rounded-full text-white transition-colors duration-200"
              aria-label="App Storeでダウンロード"
            >
              <i className="ri-apple-fill text-base sm:text-lg leading-none" aria-hidden />
            </a>
            <a
              href={googlePlayHref}
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#07DBCA] hover:bg-[#02D0F0] rounded-full text-white transition-colors duration-200"
              aria-label="Google Playでダウンロード"
            >
              <i className="ri-google-play-fill text-base sm:text-lg leading-none" aria-hidden />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
